"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Tagging_1 = require("./_Tagging");
exports.PutObjectTaggingInput = {
    type: "structure",
    required: ["Bucket", "Key", "Tagging"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        Key: {
            shape: {
                type: "string",
                min: 1
            },
            location: "uri",
            locationName: "Key"
        },
        VersionId: {
            shape: {
                type: "string"
            },
            location: "querystring",
            locationName: "versionId"
        },
        ContentMD5: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-MD5"
        },
        Tagging: {
            shape: _Tagging_1._Tagging,
            locationName: "Tagging",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        }
    },
    payload: "Tagging"
};
//# sourceMappingURL=PutObjectTaggingInput.js.map